export const cryptoCompanies = [
    { name: 'Bitcoin', symbol: 'BTC', change: '+2.5%' },
    { name: 'Ethereum', symbol: 'ETH', change: '+1.8%' },
    { name: 'Binance', symbol: 'BNB', change: '+3.2%' },
    { name: 'Cardano', symbol: 'ADA', change: '-0.5%' },
    { name: 'Solana', symbol: 'SOL', change: '+4.1%' },
    { name: 'Polkadot', symbol: 'DOT', change: '+1.2%' },
    { name: 'Avalanche', symbol: 'AVAX', change: '+2.7%' },
    { name: 'Polygon', symbol: 'MATIC', change: '+3.5%' },
    { name: 'Chainlink', symbol: 'LINK', change: '-1.2%' },
    { name: 'Uniswap', symbol: 'UNI', change: '+0.8%' },
  ];